export default __webpack_public_path__ + "static/media/logo-fluent-bit.12f81151.png";